import "./_common";
import { GlobalComponents, GlobalStores } from "../react_isomorphic/global";
import { HeaderComponents, HeaderStores } from "../react_isomorphic/site_header";
import { ReadingNotesComponents, ReadingNotesStores } from "../react_isomorphic/reading_notes";
import { merge } from "lodash";

window.ReactComponents = merge({}, GlobalComponents, HeaderComponents, ReadingNotesComponents);
window.ReactStores = merge({}, GlobalStores, HeaderStores, ReadingNotesStores);
